import { useNavigate } from 'react-router';

import { useSession } from '@/auth/session';

import { paths } from '../paths';

/**
 * Leave the back office for the counter, **signing the back office out on the
 * way** — issue #259.
 *
 * The till's sign-on screen has a door to the back office so an owner can
 * register this device for another outlet. The back-office session sits in
 * `sessionStorage` and lasts twelve hours, so on a shared terminal whoever
 * walked through the door would otherwise stay signed in behind it for the
 * next cashier to find. A sentence asking them to sign out is a sentence that
 * gets skipped at a counter with a queue; doing it is not.
 *
 * Navigates first and signs out second: the till is a public route, so the
 * guard has nothing to redirect once the session clears, whereas clearing first
 * would have the back-office guard send the person to the sign-in instead.
 */
export function useReturnToTill(): () => void {
  const navigate = useNavigate();
  const { session, signOut } = useSession();

  return () => {
    void navigate(paths.till);

    if (session !== null) void signOut();
  };
}
